export default "__VITE_ASSET__CCJHsiaC__"